
export const normalizeRotation = (r) => {
    if (r < 0) {
        r += 360;
    }
    if (r >= 360) {
        r -= 360;
    }
    return r;
};
